/**
 * ? mapController
 * @package de Zalm Property
 * 
 * Controls interactive map for the projects
 * Gets lat and lon data from ACF
 */

export default class mapController {

  constructor() {
    // Store container of project items in memory
    this.projectContainer = document.getElementById('projectContainer')
    // Initate google maps javascript API
    this.map = new google.maps.Map(document.getElementById('googleMap'), {
      center: {
        lat: 51.911148,
        lng: 4.491013
      },
      zoom: 13,
      styles: [{
          "featureType": "administrative.land_parcel",
          "stylers": [{
            "visibility": "off"
          }]
        },
        {
          "featureType": "administrative.neighborhood",
          "stylers": [{
            "visibility": "off"
          }]
        },
        {
          "featureType": "poi",
          "elementType": "labels.text",
          "stylers": [{
            "visibility": "off"
          }]
        },
        {
          "featureType": "poi.business",
          "stylers": [{
            "visibility": "off"
          }]
        },
        {
          "featureType": "road",
          "elementType": "labels",
          "stylers": [{
            "visibility": "off"
          }]
        },
        {
          "featureType": "road",
          "elementType": "labels.icon",
          "stylers": [{
            "visibility": "off"
          }]
        },
        {
          "featureType": "transit",
          "stylers": [{
            "visibility": "off"
          }]
        },
        {
          "featureType": "water",
          "elementType": "labels.text",
          "stylers": [{
            "visibility": "off"
          }]
        }
      ]
    });

    // Get marker data
    this.getMarkers();
  }

  getMarkers() {
    const items = this.projectContainer.getElementsByClassName('projects__item');

    [].forEach.call(items, (item, count) => {
      const itemPosition = new google.maps.LatLng(item.dataset.itemLat, item.dataset.itemLon);

      if (itemPosition) {
        this.placeMarker(itemPosition, item);
      }
    })

  }

  placeMarker(itemPosition, item) {
    const mapMarker = new google.maps.Marker({
      position: itemPosition,
      animation: google.maps.Animation.DROP,
      icon: '/wp-content/themes/dezalm/img/marker.svg',
      map: this.map
    })

    this.addListeners(mapMarker, item);
  }

  addListeners(mapMarker, item) {
    mapMarker.addListener('mouseover', () => {
      item.dataset.isTarget = true;
    })

    mapMarker.addListener('mouseout', () => {
      item.dataset.isTarget = false;
    })

    mapMarker.addListener('click', () => {
      window.location = item.dataset.itemHref;
    })
  }

}